@if (loading()) {
  <div class="position-relative w-100" style="height: 48px;">
    <div style="position: absolute; left: calc(50% - 25px); top: 0.5rem;">
      <mat-spinner [diameter]="25"></mat-spinner>
    </div>
  </div>
}
